import { Card } from "@rumbledirect/ui";
import {
  Dossier,
  EvaluationRule,
} from "@rumble-it/common-lib/types/models/Dossier.interface";
import { useMemo } from "react";
import { Descriptions } from "@/components/v2";

interface MatchedRulesCardProps {
  dossier: Dossier;
  isLoading?: boolean;
}

export const MatchedRulesCard = ({
  dossier,
  isLoading,
}: MatchedRulesCardProps) => {
  const sorted = useMemo(
    () =>
      [...dossier.matchedRules]
        .sort((a, b) => a.ruleSet.priority - b.ruleSet.priority)
        .filter((rule) => !rule.ruleSet.hideInAdmin),
    [dossier],
  );

  const getRuleOutput = (rule: EvaluationRule): string => {
    switch (true) {
      case rule.type === "associative_array_value" &&
        rule.output.damageClaimable !== undefined:
        return rule.output.damageClaimable ? "Verhaalbaar" : "Niet verhaalbaar";
      case rule.type === "process_allowed": {
        return {
          required: "Herstel is verplicht",
          optional: "Herstel is optioneel",
          not_allowed: "Herstel is niet toegestaan",
        }[rule.output.processAllowed];
      }
      default:
        return "Onbekend regel type, geen conclusie.";
    }
  };

  if (sorted.length === 0) {
    return null;
  }

  return (
    <Card loading={isLoading} className="w-full" title="Beslisregels">
      <div className="space-y-5">
        {sorted.map((rule) => (
          <Descriptions
            key={rule.id}
            items={[
              {
                label: "Vraag:",
                children: rule.ruleSet.name,
              },
              {
                label: "Situatie:",
                children: rule.name,
              },
              {
                label: "Conclusie:",
                children: getRuleOutput(rule),
              },
            ]}
          />
        ))}
      </div>
    </Card>
  );
};
